import axios from 'axios'
import { ElMessage } from 'element-plus'
import Router from '@/router/index'

// const BASE_URL = process.env.ENV === 'development' ? process.env.VUE_APP_ENV : '/aaa';

const BASE_URL = process.env.VUE_APP_ENV
// console.info('~~~~~~~~BASE_URL~~~~~~~~~', BASE_URL);
// console.info('process', process.env.NODE_ENV);


// 创建一个请求实例
const service = axios.create({
  baseURL: BASE_URL,
  headers: {
    'content-type': 'application/json'
  },
  timeout: 60 * 1000
})

// http request 拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    token && (config.headers.Authorization = token)
    // if (!whiteList.includes(config.url)) {
    //   SecureAxiosRequest(config)
    // }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      // 内层 200 成功
      if (response.data.code === 200) {
        // ElMessage({
        //   message: response.data.msg,
        //   type: 'success'
        // })
      }
      // 内层 400 登录过期、token 失效、没传 token，回到登陆页面
      else if (response.data.code === 400) {
        localStorage.clear()
        if (response.config.silent) {
          window.location.href="/signIn"
          ElMessage(response.data.msg)
        }      
      }
      // 内层 500 把错误信息展示出来，红色
      else if (response.data.code === 500) {
        ElMessage({
          message: response.data.msg,
          type:'error'
        })
      }
    }
    return response

  },
  // 接口错误状态处理，也就是说无响应时的处理
  (error) => {
    if (error.response.status === 0) {
      ElMessage('网络错误!')
    } else if (error.response.status === 401) {
      ElMessage('登录超时,请重新登录!')
      Router.push({ name: 'Logout' })
    } else if (error.response.status === 403) {
      ElMessage('已越权,请重新登录!')
      Router.push({ name: 'Logout' })
    }
    return Promise.reject(error.response) // 返回接口返回的错误信息
  }
)
//export default service

let POST = (url, params = {}, headers, responseType = null, silent = true) => {
  return service({
    url: url,
    method: 'post',
    data: params,
    headers: headers,
    responseType
  })
}

let GET = (url, params = {}) => {
  return service({
    url: url,
    method: 'get',
    params: params
  })
}

export { POST, GET, service }
